import { z } from "zod";
import { Interval } from "luxon";
import { Route, routeSchema } from "./route";
import type { components } from "@opstel/gen/api/v2";
import { intervalSchema } from "../utils/dateTime";

export interface AllowedActionMutations {
  currentRouteId?: string;
  allowedStartTimeInterval: Interval<true>;
  allowedEndTimeInterval: Interval<true>;
  allowedRoutes: Route[];
}

export const allowedActionMutationsSchema = z.object({
  currentRouteId: z.optional(z.uuid()),
  allowedStartTimeInterval: intervalSchema,
  allowedEndTimeInterval: intervalSchema,
  allowedRoutes: z.array(routeSchema),
}) satisfies z.ZodType<AllowedActionMutations, components["schemas"]["AllowedActionMutations"]>;
